export const getGiveawayListResponse = (response) => {
  const totalData = response?.totalData ?? 0;
  const isDataExist = response?.isDataExist;

  const giveaways = response?.giveaways?.map((item) => ({
    id: item?.id,
    createdAt: item?.createdAt,
    title: item?.title,
    status: item?.status,
    giveaways:
      item?.giveaways?.map((prize) => ({
        id: prize?.id,
        productName: prize?.productName,
        totalStock: prize?.totalStock,
        usedStock: prize?.usedStock,
        imagePath: prize?.imagePath,
      })) ?? [],
  }));

  return { giveaways, totalData, isDataExist };
};

export default getGiveawayListResponse;
